import React,{ useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Notice from "../../partials/content/Notice";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";

import Autocomplete from '@material-ui/lab/Autocomplete';

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Formik } from "formik";

import Input from '@material-ui/core/Input';


import { createSchedule,getMenus,getMappedUsers,getRoles,getAccountDetails, getProcedureTypes,getMyAccounts, getMaster,getLocations} from "../../crud/auth.crud";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';

import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';




const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  formControl: {
     // margin: theme.spacing(1),
      minWidth: 120,
    },
};





class CreateBulkSchedule extends React.Component {
  state = {
    fields:[],
    users:[],
    roles:[],
    accounts:[],
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    pentity:{},
    tasktypes:[],
    permission:[],
    assignees:[],
    selectedUsers:[],
    locations:[],
    procedureTypes:[],

  }





constructor(props)
{
  super(props);
  var date = new Date();

  if (this.props.location!=null && this.props.location.data!=null)  
  {
      console.log(this.props.location.data);
  }
  else if(props.pentities!=null)
  {
    console.log(props.pentities);
  }

  let pentity = {};
  if (this.props.location!=null && this.props.location.data!=null) 
  {
    pentity = this.props.location.data.pEntity[0];
  }
  else if(props.pentities!=null)
  {
     pentity = props.pentities[0];
  }
  else if(props.pentity!=null)
  {
    pentity = props.pentity;
  }

    this.state = {
      menu: false,
      fields:[],
      roles:[],
      users:[],
      accounts:[],
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      loading:false,
      statusColor:'alert-success',
      pentity: pentity,
      schdate: date,
      tasktypes:[],
      permission:[],
      selectedUsers:[],
      locations:[],

    };


    
  this.toggleMenu = this.toggleMenu.bind(this);
  //this.handleClick = this.handleClick.bind(this);
}

  accountChange = (e) =>
 {
      console.log("account chnage::::",e);

      getLocations(1,100,'locationName','asc',{accountKey:e.target.value})
      .then((response) => {
        this.setState({ locations:response.data})
        //console.log("patient by id::::",data);
       });
      

 }

  
  onSelectTag=(e, value)=> {

let tguser=[];
  if(value!=null)
  {
    value.map((acc)=>(
      tguser.push(acc.userId)
      ))
    console.log(tguser);
    this.setState({selectedUsers:tguser});
  }
}


  toggleMenu()
  {
    this.setState({ menu: !this.state.menu })
  }

  componentDidMount()
  {
    
    /*getFields().then(response => response.data)
    .then((data) => {
      this.setState({ fields: data[0].fields })
      //console.log(data[0].fields);
     //console.log(this.state.users)
     })
     */

     getMappedUsers().then(response => response.data)
    .then((data) => {
      let users =[];
      data.map((x)=>{
        if(x.locationKey===null)
        { x.locationKey="";
         users.push(x);
       }
       else
       {
        users.push(x);
       }
      }
      )
      this.setState({ users: users })
      //console.log("users:::",users)
     })

     getRoles().then(response => response.data)
    .then((data) => {
      this.setState({ roles: data })
      //console.log(this.state.users)
     })

    getMaster("tasktype").then(response => response.data)
    .then((data) => {
      this.setState({ tasktypes: data })
      //console.log(this.state.users)
     })

    getMyAccounts().then(response => response.data)
    .then((data) => {
      this.setState({ accounts: data })
      //console.log(this.state.users)
     })

    

     getProcedureTypes().then(response => response.data)
    .then((data) => {
      //this.setState({ procedureTypes: data })
      let filtered=[];
      let procedureTypes =data;
       getAccountDetails().then(response => response.data)
      .then((data) => {
        console.log("prppp::",data);
        if(data.procedureTypes!=null)
        {
          data.procedureTypes.map((pt)=>(
            procedureTypes.filter(x=>x.procedureTypeKey===pt).map((p)=>(
                filtered.push(p)
              ))
            ))
        }
        console.log("filtered prtyy:::::",filtered);
        this.setState({ procedureTypes: filtered })
      //console.log(this.state.users)
      })

      //console.log(this.state.users)
     })

     getMenus().then(response => response.data)
    .then((data) => {
      
      if(data[0] != null && data[0].permissions !=null)
                {
                 
                  console.log(data[0].permissions);
                  let perms="";
                  data[0].permissions.map((per) =>(
                    perms = perms + "," + per
                    ))
                  console.log(perms);
                   this.setState({ permission: perms })

                }
     })
  }

  
handleClickDetails(user)
  {
    return function(){
      console.log('handleClickDetails');
    }

    
  
} 



  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;
     const pentity = this.state.pentity;
     

    return (
      <>
          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}

          <Formik
                  initialValues={{
                    accountId:"",
                    roleId:"",
                    userId:[],
                    scheduleType:"",
                    pEntityId:"",
                    startDate:"",
                    endDate:"",
                    notes:"",
                    taskTypeId:"TTP00001",
                    locationKey:""
                 }}
                  validate={values => {
                    const errors = {};

                   

                    if (!values.taskTypeId) {
                      errors.taskTypeId = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.accountId) {
                      errors.accountId = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                   

                   

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting ,setFieldValue}) => {

                   this.setState({loading:true});
                    let selectedUsers = this.state.selectedUsers;
                    console.log("selected users arrar:::",selectedUsers);
                    if(selectedUsers!==null && selectedUsers.length>0)
                    {
                      selectedUsers.map((usr) => (

                          createSchedule(
                            values.accountId,
                            "",
                            usr,
                            "",
                            this.state.pentity.pEntityId,
                            this.state.schdate,
                            values.endDate,
                            values.notes,
                            values.taskTypeId,
                            values.locationKey,
                            values.procedureTypeKey
                           
                            
                          )
                            .then(resp => {
                            
                             
                            })
                            .catch(() => {
                              setSubmitting(false);
                              this.setState({loading:false,isSubmitting:false});
                            })
                          ))

                        //props.register(accessToken);
                             setSubmitting(false);
                             setFieldValue('roleId',"");
                             //setFieldValue('userId',"");
                             setFieldValue('accountId',"");
                              this.setState({status:true,isSubmitting:false,loading:false,
                              statusMessage:'New To Do assigned successfully',selectedUsers:[],tguser:[],
                              alertType:'alert-success',statusColor:'alert-success'});
                               //window.scrollTo(0,0);

                    }
                    else
                    {
                      setSubmitting(false);
                      this.setState({status:true,isSubmitting:false,loading:false,
                              statusMessage:'Unable to process, user selection is mandatory',selectedUsers:[],tguser:[],
                              alertType:'alert-danger',statusColor:'alert-danger'});
                    }
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      
          
    
          <div className="kt-section">
            <div className="kt-section__content">
            

         
                      <div className="row">
                       <div className="col">
                        <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="taskTypeId-label">Select To Do</InputLabel>
                             <Select
                              labelId="taskTypeId-label"
                              id="taskTypeId"
                              onChange={handleChange}
                              margin="normal"
                              name="taskTypeId"
                              value={values.taskTypeId}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="kt-width-full"

                              
                            >
                            
                              {this.state.tasktypes.map((ttp) =>(

                              (this.state.permission.includes("ALLOWEDTYPE:"+ttp.taskTypeId) || ttp.taskTypeId === values.taskTypeId || !this.state.permission.includes("ALLOWEDTYPE"))&& <MenuItem key={ttp.taskTypeId} value={ttp.taskTypeId} selected={ttp.taskTypeName==='Referred'? true:false}>{ttp.taskTypeName}</MenuItem>
                                 
                              
                              ))}
                            </Select>
                         </FormControl>
                         </div>
                      </div>
                      <div className="row">
                       <div className="col">
                        <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="procedureTypeKey-label">Procedure Type</InputLabel>
                             <Select
                              labelId="procedureTypeKey-label"
                              id="procedureTypeKey"
                              onChange={handleChange}
                              margin="normal"
                              name="procedureTypeKey"
                              value={values.procedureTypeKey}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="kt-width-full"

                              
                            >
                            
                              {this.state.procedureTypes!=null && this.state.procedureTypes.map((pt) =>(

                               <MenuItem key={pt.procedureTypeKey} value={pt.procedureTypeKey} >{pt.procedureTypeName}</MenuItem>
                                 
                              
                              ))}
                            </Select>
                         </FormControl>
                         </div>
                      </div>
                      <div className="row">
                         <div className="col">

                         <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container justify="space-around">
                        <KeyboardDatePicker
                              variant="inline"
                              format="MM/dd/yyyy"
                              margin="normal"
                              id="startDate"
                              name="startDate"
                              label="Task Date"
                              value={this.state.schdate}
                              onChange={value => {
                                this.setState({schdate:value})
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />

                        </Grid>
                        </MuiPickersUtilsProvider>
                        </div>
                      </div>        

                         

                     
                     <div className="row">
                        <div className="col">
                          <TextField
                            margin="normal"
                            label="Notes"
                            className="kt-width-full"
                            name="notes"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.notes}
                            helperText={touched.notes && errors.notes}
                            error={Boolean(touched.notes && errors.notes)}
                          />
                        </div>
                      </div>    
                      
             
              <div className="row">
                 <div className="col">
                      <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="accountId-label">Assign To</InputLabel>
                             <Select
                              labelId="accountId-label"
                              id="accountId"
                              margin="normal"
                              name="accountId"
                              value={values.accountKey}
                               onChange={(e)=>{handleChange(e);this.accountChange(e);}}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                               input={<Input />}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {this.state.accounts.map((acc) =>(

                              <MenuItem value={acc.accountId}>{acc.accountName +' (' + acc.businessEntity +')'}</MenuItem>
                              
                              ))}
                            </Select>
                         </FormControl>
                  </div>
                  <div className="col">
                      <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="locationKey-label">Location</InputLabel>
                             <Select
                              labelId="locationKey-label"
                              id="locationKey"
                              margin="normal"
                              name="locationKey"
                              value={values.locationKey}
                             onChange={handleChange}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                               input={<Input />}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {this.state.locations.map((loc) =>(

                              <MenuItem value={loc.locationKey}>{loc.locationName}</MenuItem>
                              
                              ))}
                            </Select>
                         </FormControl>
                  </div>

              {(this.state.permission!=null && !this.state.permission.includes("DENY:TASKASSIGNMENT") &&  
             <div className="col">
                <FormControl className={classes.formControl} style={{'width':'100%'}}>
             
                          <InputLabel shrink id="roleId-label">Select Role</InputLabel>
                             <Select
                              labelId="roleId-label"
                              id="roleId"
                              onChange={handleChange}
                              margin="normal"
                              name="roleId"
                              value={values.roleId}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                               input={<Input />}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                            {this.state.roles.map((role)=>(
                                role.roleName !== 'SASADMIN' &&  role.roleName !== 'PORTALADMIN' &&
                                <MenuItem value={role.roleId}>{role.roleDescription}</MenuItem>
                                
                              ))}
                            
                            

                            </Select>
                        </FormControl>
              </div>
              )}
              </div>

              <div className="row">
              {(this.state.permission!=null && !this.state.permission.includes("DENY:TASKASSIGNMENT") && values.locationKey==="" &&
                <div className="col">
              
                     <FormControl className={classes.formControl} style={{'width':'100%'}}>
                     
                     <Autocomplete
                        multiple
                        id="tags-standard"
                        options={this.state.users.filter(x=>x.roleKey===values.roleId && x.accountKey===values.accountId)}
                        onChange={this.onSelectTag}

                        getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
                        renderInput={(params) => (
                                  <TextField
                                  {...params}
                                      margin="normal"
                                      label="Select User"
                          />
                       )}
                      />
                    
                   
                      </FormControl>
               </div>
              )}
              </div>
              <div className="row">
              {(this.state.permission!=null && !this.state.permission.includes("DENY:TASKASSIGNMENT") && values.locationKey!=="" &&
                <div className="col">
              
                     <FormControl className={classes.formControl} style={{'width':'100%'}}>
                     
                     <Autocomplete
                        multiple
                        id="tags-standard"
                        options={this.state.users.filter(x=>x.roleKey===values.roleId && x.accountKey===values.accountId && x.locationKey===values.locationKey)}
                        onChange={this.onSelectTag}

                        getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
                        renderInput={(params) => (
                                  <TextField
                                  {...params}
                                      margin="normal"
                                      label="Select User"
                          />
                       )}
                      />
                    
                   
                      </FormControl>
               </div>
              )}
              </div>
              <div className="row">
                <div className="col">
                    <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                           Assign To Do
                        </button>
                </div>
              </div>
           
              
              
        </div>
        </div>
        
        <div className="kt-login__actions">
                       

                        
                      </div>
              

        </form>
            )}
            </Formik>
          
      

       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(CreateBulkSchedule));

